import axios from 'axios'
//import store from '@/store'


export default () => {
  const token = localStorage.getItem('access_token');
  return axios.create({
    baseURL: 'https://sviluppoallergeni.confcom.it',
    withCredentials: true,
    headers: {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  })
}
